import React from 'react'
import { Select, Button, message, Table, Radio, Modal, Steps, Space, Popconfirm } from 'antd'
import moment from 'moment'
import 'moment/locale/zh-cn'
import common from '@/public/common'
import styles from './commodity-management-list.module.less'
import _lodash,{get} from 'lodash'
import {getCookieNew,getCookie} from '@/public/utils'
import {PlusOutlined} from '@ant-design/icons'
import { ajaxApi } from '../../../server'
const Option = Select.Option
const { Step } = Steps
class TableComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedRowKeys: [],
      selectedArr: [],
      categoryArr: [],
      tableData: [],
      deieteLoading: false,
      btnloading: false,
      modalvisible: false,
      addData: {
        'action': '',
        'item_info': {
          'id': null,
          'is_cross_border': null,
          'brand_id': null,
          'brand_name': '',
          'category_id': null,
          'category_name': '',
          'item_color_type': '',
          'item_series': '',
          'english_name': '',
          'creater': getCookieNew('supplier_code')|| null,
          'create_ch': getCookieNew('supplier_company_name') || null,
          'create_time': null,
          'spec': '',
          'spec_unit': '',
          'item_material': '',
          'item_useful_life': null,
          'useful_unit': '',
          'is_customed': null,
          'weight': null,
          'packing_specification': '',
          'logistics_service': '',
          'origin_place': undefined,
          'create_company': '',
          'operation': '',
          'is_one_sale': null,
          'distribute_type': '',
          'distribute_number': null,
          'promote_desc': '',
          'purchase_desc': '',
          'pay_type': '',
          'pay_day': null,
          'pay_cycle': '',
          'tax_rate': null,
          'after_sale_problem': '',
          'settle_price': null,
          'price_unit': '',
          'produce_cycle': null,
          'delivery_day': null,
          'sale_price': null,
          'is_supply_complaint': null,
          'is_rebate': undefined,
          'rebate_type': '',
          'rebate_point': null,
          'rebate_base': '',
          'rebate_note': '',
          'gross_rate': null,
          'gross_money': null,
          'rebate_cost': null,
          'is_import': '',
          'produce_type': '',
          'medical_name': '',
          'main_function': '',
          'storages': [],
          'pro_model': '',
          'currency':null,
        },
        'extend_propertys': [

        ],
        'sku_propertys': [

        ],
        'contact_property': {
          'change_cycle': '',
          'water': '',
          'refraction': '',
          'oxygen': '',
          'first_thickness': '',
          'second_thickness': '',
          'third_thickness': '',
          'oxy_unit': '',
          'thickness_list': [
            {
              'thickness_begin': '',
              'thickness_end': '',
              'thickness': ''
            }
          ]
        },
        'color_propertys': [
          {
            'color': '',
            'base_arc': '',
            'dia': '',
            'color_dia': ''
          }
        ],
        'degrees': [''],
        'six_images': []
      }
    }
  }

  componentDidMount () {
    if (this.props.opration === true) {
      this.setState({
        selectedRowKeys: [],
        selectedArr: []
      })
    }
    this.setState({
      categoryArr: this.props.categoryArr,
      tableData: this.props.tableData,
      supplierTradeType:get(getCookieNew('supplierinfo')?JSON.parse(getCookieNew('supplierinfo')):'','trade_type')
    })
  }

  componentWillReceiveProps (nextprops) {
    if (nextprops.opration === true) {
      this.setState({
        selectedRowKeys: [],
        selectedArr: []
      })
    }
    this.setState({
      categoryArr: nextprops.categoryArr,
      tableData: nextprops.tableData
    })
  }

  // 添加
  handleAdd=() => {
    this.setState({
      modalvisible: true
    })
  }

  // 取消
  handleCancel=() => {
    this.setState({
      modalvisible: false
    })
  }

  // 获取下拉框的值
  handelChangeSource=(e, name) => {
    let {addData, categoryArr} = this.state
    addData.item_info[name] = e
    if (name === 'category_id') {
      // categoryArr 来自新接口 product/list/select-option
      // category_id 存旧 id（old_category_code），同时记录新的 category_code 供详情页取子类目
      _lodash.forEach(categoryArr, (item, index) => {
        if (e === item.old_category_code) {
          addData.item_info.category_name = item.category_name
          addData.item_info.category_code = item.category_code
        }
      })
    }
    this.setState({
      addData
    })
  }

  // 获取单选框的值
  onChangeRadio = (e, name) => {
    let {addData} = this.state
    if(name=='is_cross_border'){
      addData.item_info['tax_rate'] = e.target.value?0:null
    }
    addData.item_info['currency'] = this.getDefaultCurrency()
    console.log(getCookie('supplierinfo'))
    addData.item_info[name] = e.target.value
    this.setState({
      addData
    })
  }

  getDefaultCurrency = () => {
    return getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).currency : null
  }

  // 根据老 category_id(old_category_code) 反查新类目编码 category_code
  resolveCategoryCode = (oldCategoryCode) => {
    const {categoryArr} = this.state
    if (!categoryArr || !oldCategoryCode) return ''
    const target = _lodash.find(categoryArr, ['old_category_code', String(oldCategoryCode)])
    return get(target, 'category_code') || ''
  }

  // 开始录入
  handleSubmit=async () => {
    let {addData} = this.state
    try {
      if (addData.item_info.is_cross_border === '' || addData.item_info.is_cross_border === null || addData.item_info.category_id === '' || addData.item_info.category_id === null) {
        message.warning('请选择必填项', 1.5)
        return
      }
      // 选中类目时已记录新的 category_code，缺失则按老 id 反查
      if (!addData.item_info.category_code) {
        addData.item_info.category_code = this.resolveCategoryCode(addData.item_info.category_id)
      }
      sessionStorage.setItem('addData', JSON.stringify(addData))
      const url = `${'/main/commoditymanagement/addinfomation/add-infomation'}${'?iscrossborder='}` + addData.item_info.is_cross_border + '&categoryid=' + addData.item_info.category_id + '&categorycode=' + (addData.item_info.category_code || '') + '&type=add'
      window.open(url)
      this.setState({
        modalvisible: false
      })
    } catch (e) {
      // console.log(e)
    }
  }

  // 编辑
  handleEdit = (record) => {
    this.publicFunc(record, 'edit')
  }

  // 详情
  handleDetail = (record) => {
    this.publicFunc(record, 'detail')
  }

  // 获取详情
  publicFunc = async (record, type) => {
    const res = await ajaxApi({
      url: common.scpUrl + 'item/query-detail',
      params: {id: record.id}
    })
    if (res.status === 200) {
      // 详情/编辑场景下 record 可能只有老的 category_id，按映射补齐新的 category_code 带入 url
      const categoryCode = record.category_code || this.resolveCategoryCode(record.category_id)
      var urlstr = `${'/main/commoditymanagement/commodityqualification/commodity-qualification'}${'?itemId='}` +
      record.item_id + '&itemName=' + record.item_name + '&quaItemId=' + record.qua_item_id
      if (type === 'edit') {
        var detailsData = {...res.data, qualificationurl: urlstr}
        _lodash.set(detailsData,'extend_propertys',_lodash.reject(_lodash.get(detailsData,'extend_propertys',[]),['property_name','ContactsType']))
        sessionStorage.setItem('addData', JSON.stringify(detailsData))
        let url = `${'/main/commoditymanagement/addinfomation/add-infomation'}${'?iscrossborder='}` +
        record.is_cross_border + '&categoryid=' + record.category_id + '&categorycode=' + (categoryCode || '') + '&id=' + record.id + '&type=edit'
        setTimeout(function () {
          window.open(url)
        }, 1500)
      } else {
        var detailsData = {...res.data, qualificationurl: urlstr}
        _lodash.set(detailsData,'extend_propertys',_lodash.reject(_lodash.get(detailsData,'extend_propertys',[]),['property_name','ContactsType']))
        sessionStorage.setItem('detailsData', JSON.stringify(detailsData))
        let url = '/main/commoditymanagement/newproductdetails/details-infomation?id=' + record.id + '&categoryid=' + record.category_id + '&categorycode=' + (categoryCode || '')
        setTimeout(function () {
          window.open(url)
        }, 1500)
      }
    }
  }

  // 终止引入
   terminationIntroduction = async (record) => {
     const res = await ajaxApi({
       url: common.scpUrl + 'item/close-import',
       params: {id: record.id}
     })
     if (res.status === 200) {
       this.props.getTableData()
     }
   }

   // 再次引入
   handleReintroduce = async (record) => {
     const res = await ajaxApi({
       url: common.scpUrl + 'item/again-import',
       params: {id: record.id}
     })
     if (res.status === 200) {
       this.props.getTableData()
     }
   }

  // 操作
  operationFun=(record) => {
    if (record.import_part === 'first') {
      if (record.status === 'to_submit' || record.status === 'to_edit') {
        return (
          <Space>
            <a onClick={() => this.handleEdit(record)}>编辑</a>
            <a onClick={() => this.handleDetail(record)}>详情</a>
            <a onClick={() => this.terminationIntroduction(record)}>终止引入</a>
          </Space>
        )
      } else {
        if (record.import_result === 'refuse_import') {
          return (
            <Space>
              <a onClick={() => this.handleReintroduce(record)}>再次引入</a>
              <a onClick={() => this.handleDetail(record)}>详情</a>
            </Space>
          )
        } else {
          return (
            <a onClick={() => this.handleDetail(record)}>详情</a>
          )
        }
      }
    }

    if (record.import_part === 'second') {
      if (record.status === 'to_complete' || record.status === 'to_edit') {
        return (
          <Space>
            <a target="_blank" href={ `${'/main/commoditymanagement/commodityqualification/commodity-qualification'}${'?itemId='}` +
             record.item_id + '&itemName=' + record.item_name + '&quaItemId=' + record.qua_item_id }>资质上传</a>
            <a onClick={() => this.handleDetail(record)} >详情</a>
          </Space>
        )
      } else {
        if (record.import_result === 'refuse_import') {
          return (
            <Space>
              <a onClick={() => this.handleReintroduce(record)}>再次引入</a>
              <a onClick={() => this.handleDetail(record)}>详情</a>
            </Space>
          )
        } else {
          return (
            <a onClick={() => this.handleDetail(record)}>详情</a>
          )
        }
      }
    }
  }

  // 删除
   handleDelete = async () => {
     const {selectedArr} = this.state
     const idArr = []
     if (selectedArr.length === 0) {
       message.warning('请勾选需要删除的待创建的商品', 3)
       return
     }
     selectedArr.forEach(item => {
       idArr.push(item.id)
     })
     this.setState({
       deieteLoading: true
     })
     const res = await ajaxApi({
       url: common.scpUrl + 'item/delete-item',
       params: {ids: idArr}
     })
     if (res.status === 200) {
       this.setState({
         deieteLoading: false,
         selectedRowKeys: [],
         selectedArr: []
       }, () => {
         this.props.getTableData()
       })
     }
   }

   render () {
     let {selectedRowKeys} = this.state
     // 列表复选框
     const rowSelection = {
       onChange: (selectedRowKeys, selectedRows) => {
         this.setState({
           selectedArr: selectedRows,
           selectedRowKeys: selectedRowKeys
         })
       },
       selectedRowKeys: selectedRowKeys,
       getCheckboxProps: record => ({
         disabled: record.status !== 'to_submit'
       })
     }

     const columns = [
       {
         title: '编码',
         dataIndex: 'item_code',
         key: 'item_code',
         align: 'center',
         render: (text, record) => (
           <span>{record.item_code ? record.item_code : '-'}</span>
         )
       },
       {
         title: '商品名称',
         dataIndex: 'item_name',
         key: 'item_name',
         align: 'center',
         width: '250px',
         render: (text, record) => (
           <span>{record.item_name ? record.item_name : '-'}</span>
         )
       },
       {
         title: '商品品牌',
         dataIndex: 'brand_name',
         key: 'brand_name',
         align: 'center',
         render: (text, record) => (
           <span>{record.brand_name ? record.brand_name : '-'}</span>
         )
       },
       {
         title: '商品类别',
         dataIndex: 'category_name',
         key: 'category_name',
         align: 'center',
         render: (text, record) => (
           <span>{record.category_name ? record.category_name : '-'}</span>
         )
       },
       {
         title: '引入阶段',
         dataIndex: 'import_part',
         key: 'import_part',
         align: 'center',
         render: (text, record) => {
           if (record.import_part) {
             if (record.import_part === 'first') {
               return '初审阶段'
             }
             if (record.import_part === 'second') {
               return '复审阶段'
             }
           } else {
             return '-'
           }
         }
       },
       {
         title: '阶段状态',
         dataIndex: 'status',
         key: 'status',
         align: 'center',
         render: (text, record) => {
           if (record.status) {
             if (record.status === 'to_submit') {
               return '待提交'
             }
             if (record.status === 'to_check') {
               return '待审核'
             }
             if (record.status === 'to_complete') {
               return '待补充'
             }
             if (record.status === 'on_check') {
               return '审核中'
             }
             if (record.status === 'pass_check') {
               return '审核通过'
             }
             if (record.status === 'refuse_check') {
               return '审核拒绝'
             }
             if (record.status === 'to_edit') {
               return '返回修改'
             }
             if (record.status === 'closed') {
               return '已关闭'
             }
           } else {
             return '--'
           }
         }
       },
       {
         title: '最终结果',
         dataIndex: 'import_result',
         key: 'import_result',
         align: 'center',
         render: (text, record) => {
           if (record.import_result) {
             if (record.import_result === 'to_import') {
               return '待引入'
             }
             if (record.import_result === 'pass_import') {
               return '引入成功'
             }
             if (record.import_result === 'refuse_import') {
               return '引入失败'
             }
           } else {
             return '-'
           }
         }
       },
       {
         title: '提交日期',
         dataIndex: 'create_time',
         key: 'create_time',
         align: 'center',
         render: (text, record) => (
           <span>{record.create_time ? moment(record.create_time).format('YYYY-MM-DD HH:mm:ss') : '-'}</span>
         )
       },
       {
         title: '操作',
         dataIndex: 'opration',
         key: 'opration',
         align: 'center',
         width: '200px',
         render: (text, record) => (
           <span>
             {this.operationFun(record)}
             {/* <Space>
               <a target="_blank" href={ `${'/main/commoditymanagement/addinfomation/add-infomation'}${'?iscrossborder='}` + record.is_cross_border + '&categoryid=' + record.category_id + '&id=' + record.id + '&type=edit'}>编辑</a>
               <a target="_blank" href={'/main/commoditymanagement/newproductdetails/details-infomation?id=' + record.id}>详情</a>
               <a>关闭引入</a>
              </Space> */}
           </span>
         )
       }
     ]
     return (
       <div>
         <div style={{margin: '16px 0px'}}>
           <Button type='primary' style={{marginRight: '16px'}} onClick={this.handleAdd} shape="round"><PlusOutlined />添加</Button>
           <Popconfirm placement="topLeft" title={'删除该信息后，该数据将全部丢失，请谨慎操作！'} onConfirm={this.handleDelete} okText="确定" cancelText="取消">
             <Button type='' loading={this.state.deieteLoading} shape="round">删除</Button>
           </Popconfirm>
         </div>
         <Table
           bordered={false}
           onChange={this.handleSort}
           rowKey={record => record.key}
           dataSource={this.state.tableData}
           rowSelection={rowSelection}
           pagination={false}
           columns={columns}
         >
         </Table>

         <Modal
           title='添加新品'
           open={this.state.modalvisible}
           onOk={this.handleOk}
           footer = {null}
           style={{marginTop: '5%'}}
           onCancel={this.handleCancel}
         >
           <Steps current={1}>
             <Step title={'商品基础信息'} description={<div style={{width: 250}}><div>初审阶段：商品基础信息</div><div>六面图，合作政策提交与审核</div></div>} />
             <Step title={'监管合规'} subTitle="" description={<div ><div>复审阶段：监管合规</div><div>资料提交，邮寄与审核</div></div>} />
           </Steps>

           <div style={{display: 'none'}}>
             <span className={styles.publicspan}><span style={{color: 'red'}}>*</span>录入方式：</span>
             <Radio.Group onChange={(e) => this.onChangeRadio(e, 'input_type')} >
               <Radio value='base'>录入商品基本信息</Radio>
               <Radio value='complete'>录入商品完整信息</Radio>
             </Radio.Group>
           </div>

           <div style={{margin: '26px 0px', display: 'none'}}>
             <span className={styles.publicspan}><span style={{color: 'red'}}>*</span>监管类别：</span>
             <Radio.Group onChange={(e) => this.onChangeRadio(e, 'charge_level')} value={this.state.addData.item_info.charge_level ? this.state.addData.item_info.charge_level : '' }>
               <Radio value='medical'>医疗器械</Radio>
               <Radio value='unmedical'>非医疗器械</Radio>
             </Radio.Group>
           </div>
          <div style={{margin: '16px 0px'}}>
            <span className={styles.publicspan}><span style={{color: 'red'}}></span>销售主体：</span>
              {getCookie('business_name') || '--'}
           </div>
           <div style={{margin: '16px 0px'}}>
             <span className={styles.publicspan}><span style={{color: 'red'}}>*</span>商品类别：</span>
             <Select
               showSearch
               style={{ width: 196, marginRight: '0px' }}
               optionFilterProp="children"
               placeholder='请选择'
               onChange={(e) => this.handelChangeSource(e, 'category_id')}
             >
               {(this.state.categoryArr || this.state.categoryArr.length === 0) ? this.state.categoryArr.map((item, index) => (
                 <Option key={index + 1} name='category_id' value={item.old_category_code}>{item.category_name}</Option>
               )) : null}
             </Select>
           </div>

           <div style={{}}>
             <span className={styles.publicspan}><span style={{color: 'red'}}>*</span>是否海淘：</span>
             <Radio.Group onChange={(e) => this.onChangeRadio(e, 'is_cross_border')}>
               <Radio value={1} disabled={this.state.supplierTradeType!='KJTrade'}>海淘</Radio>
               <Radio value={0} disabled={this.state.supplierTradeType=='KJTrade'}>非海淘</Radio>
             </Radio.Group>
           </div>

           <div style={{ textAlign: 'center', marginTop: '4%' }}>
             <Button onClick={this.handleSubmit} loading ={this.state.btnloading} type='primary' shape="round">开始录入</Button>
             <Button onClick={this.handleCancel} style={{ marginLeft: '7%' }} shape="round">取消</Button>
           </div>
         </Modal>
       </div>
     )
   }
}
export default TableComponent



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commoditymanagementlist/tablecomponent.js